class Dialog {
    constructor(triggerEl, dialogEl) {
        this.trigger = triggerEl;
        this.dialog = dialogEl;

        this.linkTriggerToDialog();
        // this.livewireHooks();
        this.addClose();
    }

    linkTriggerToDialog() {
        this.trigger.addEventListener("click", this.openDialog.bind(this));
    }

    livewireHooks() {
        window.Livewire.hook(
            "message.processed",
            this.linkTriggerToDialog.bind(this)
        );
    }

    openDialog() {
        this.dialog["MDCDialog"].open();
    }

    closeDialog() {
        this.dialog["MDCDialog"].close();
    }

    addClose() {
        const closeBtn = this.dialog.querySelector(".mdc-dialog__close-icon");
        if (closeBtn) {
            closeBtn.addEventListener("click", this.closeDialog.bind(this));
        }
    }
}

function findDialogs(el) {
    Array.from(
        document.querySelectorAll("[data-dialog-trigger]")
    ).forEach(item => initDialog(item));
}

function initDialog(item) {
    if (item.dataset.dialogUid) {
        var trigger = item;
        var dialog = document.querySelector(
            "[data-dialog-content][data-dialog-uid=" +
                item.dataset.dialogUid +
                "]"
        );
        new Dialog(trigger, dialog);
    }
}

window.addEventListener("DOMContentLoaded", function() {
    findDialogs(document);
    // Init new dialogs on livewire update
    window.Livewire.hook("message.processed", function(e) {
        findDialogs(e.el);
    });
});
